/**
 * @file portalAccessUtil.js
 * @description Utilities for verifying that an Individual has access to a portal page.
 */

import {
    readPortalPage,
    readScopedPortalPage,
} from '../services/portalPageService';

const NO_PORTAL_ACCESS_CODE = 'NO_PORTAL_ACCESS';

function createNoPortalAccessError() {
    const error = new Error(NO_PORTAL_ACCESS_CODE);
    error.code = NO_PORTAL_ACCESS_CODE;
    return error;
}

export async function checkPortalAccess({ portalId, isViewLive }) {
    try {
        if (Boolean(isViewLive)) {
            await readPortalPage(portalId);
            return true;
        }

        await readScopedPortalPage(portalId);
        return true;
    } catch (error) {
        const status = error?.response?.status;
        if (status === 404) {
            throw createNoPortalAccessError();
        }

        throw error;
    }
}
